<template>
  <section>
    <!--工具条-->
    <el-col :span="6" class="toolbar">
      <el-input placeholder="用户昵称" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
      <el-table-column type="expand">
        <template scope="scope">
          <el-collapse v-model="activeNames" accordion>
<!--             <el-collapse-item title="宠物信息" name="1">
              <el-tabs v-model="petsAction" type="border-card">
                <el-tab-pane
                  v-for="(item, index) in petsTabs"
                  :label="item.pet_name"
                  :name="item.pet_name"
                  :key="index">
                  <el-row>
                    <el-col :offset="2" :span="2">宠物姓名：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.pet_name}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">宠物性别：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{sexData[item.sex]}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :offset="2" :span="2">宠物生日：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.birthday}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">宠物介绍：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.pet_intro}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :offset="2" :span="2">宠物照片：</el-col>
                    <el-col :span="20">
                      <a v-for="(pic, i) in item.pet_pics.split(',')" :href="pic" :key="i" target="_blank">
                        <img style="width: 50px; height: 50px;" :src="pic" />
                      </a>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-collapse-item> -->

            <el-collapse-item title="收货地址" name="1">
              <el-tabs v-model="addressAction" type="border-card">
                <el-tab-pane
                  v-for="(item, index) in addressTabs"
                  :label="'地址'+parseInt(index+1)"
                  :name="'地址'+parseInt(index+1)"
                  :key="index">
                  <el-row>
                    <el-col :offset="2" :span="2">收货人姓名：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.addr_name}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">联系方式：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.tel}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :offset="2" :span="2">省市县：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.sheng}}{{item.shi}}{{item.xian}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">详细地址：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.addr_detail}}</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :offset="2" :span="2">默认地址：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{defaultAddress[item.is_default]}}</div>
                    </el-col>
                    <el-col :offset="2" :span="2">身份证号：</el-col>
                    <el-col :span="8">
                      <div class="user-font">{{item.card_num}}</div>
                    </el-col>
                  </el-row>
              <el-row>  <el-col :offset="2" :span="2">地址汇总：</el-col>
                <el-col :span="20">
                  <div class="user-font">{{item.addr_name}} {{item.tel}} {{item.sheng}} {{item.shi}} {{item.xian}} {{item.addr_detail}} {{item.card_num}}</div>
                </el-col>
                </el-row> 
            <!--       <el-row>
                    <el-col :offset="2" :span="2">身份证照片：</el-col>
                    <el-col :span="20">
                      <a v-for="(pic, i) in item.card_pic.split(',')" :href="pic" :key="i" target="_blank">
                        <img style="width: 50px; height: 50px;" :src="pic" />
                      </a>
                    </el-col>
                  </el-row> -->
                </el-tab-pane>
              </el-tabs>
            </el-collapse-item>

            <el-collapse-item title="返利信息" name="2">
              <el-table :data="tableFanli">
                <el-table-column
                  label="订单编号"
                  prop="order_num"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="应返天然豆数"
                  prop="coins"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="返利状态"
                  align="center">
                  <template scope="scope">
                    <div>{{fanliStatus[scope.row.fanli_status]}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建时间"
                  prop="create_time"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="center">
                  <template scope="scope">
                    <el-button :plain="true" type="info" size="small" @click="showOrder(scope.row.usid, scope.row.order_num)">查看订单</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </template>
      </el-table-column>
           <el-table-column
        label="用户编号"
        prop="usid"
        align="center">
      </el-table-column>
      <el-table-column
        label="微信编号"
        prop="open_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="昵称"
        prop="name"
        align="center">
      </el-table-column>
     <!--  <el-table-column
        label="性别"
        align="center">
        <template scope="scope">
          <div>{{sexData[scope.row.sex]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="联系方式"
        prop="tel"
        align="center">
      </el-table-column> -->
      <el-table-column
        label="天然豆"
        prop="coins"
        align="center">
      </el-table-column>
 <!--      <el-table-column
        label="邮箱"
        prop="email"
        align="center">
      </el-table-column> -->
      <el-table-column
        label="用户状态"
        align="center">
        <template scope="scope">
          <div>{{userStatus[scope.row.user_status]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="等级"
        align="center">
        <template scope="scope">
          <div>{{userLevel[scope.row.level]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="来源"
        align="center">
        <template scope="scope">
          <div>{{userChannel[scope.row.chennel]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="最近登陆时间"
        prop="lately_at"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="状态"
        align="center">
        <template scope="scope">
          <div>{{status[scope.row.status]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        prop="labels"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="info" size="small" @click="showEdit(scope.row)">修改</el-button>
          <el-button :plain="true" type="info" size="small" @click="showOrder(scope.row.usid, '')">查看订单</el-button>
          <el-button :plain="true" type="info" size="small" @click="showComment(scope.row.usid)">查看评论</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--修改界面-->
    <el-dialog title="修改" v-model="editFormVisible">
      <el-row>
        <el-col :offset="2" :span="4">用户等级：</el-col>
        <el-col :span="16">
          <el-select v-model="editForm.level" placeholder="请选择">
            <el-option
              v-for="(item, value) in userLevel"
              :key="value"
              :label="item"
              :value="value"
              size="small">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-col :offset="2" :span="4">分销商：</el-col>
        <el-col :span="16">
          <el-select v-model="editForm.refid" placeholder="请选择">
            <el-option
              v-for="(item, value) in userRefid"
              :key="value"
              :label="item"
              :value="value"
              size="small">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row style="margin-top: 20px;">
        <el-col :offset="2" :span="4">用户状态：</el-col>
        <el-col :span="16">
          <el-switch
            v-model="editForm.user_status"
            on-color="#ff4949"
            off-color="#13ce66"
            on-value='1'
            off-value='0'
            on-text="冻结"
            off-text="正常">
          </el-switch>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        sexData: basicdata.sexData,
        userStatus: basicdata.userStatus,
        userLevel: basicdata.userLevel,
        userChannel: basicdata.userChannel,
        status: basicdata.status,
        defaultAddress: basicdata.defaultAddress,
        userRefid: basicdata.userRefid,
        activeNames: '1',
        expands: [],
        getRowKeys(row) {
          return row.usid;
        },
        petsAction: '',
        petsTabs: [],
        addressAction: '地址1',
        addressTabs: [],
        submitLoading: false,
        editFormVisible: false,
        editForm: {},
        tableFanli: [],
        fanliStatus: basicdata.fanliStatus,
        usid: 0
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        let url = config.api_url + '/userinfo/page';
        if(this.usid > 0) {
          url += '/' + this.usid;
        }
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //查询宠物，等。
      expand(row, expanded) {
        if(expanded) {
          // this.getPets(row.usid);
          this.getAddress(row.usid);
          this.getFanli(row.usid);
          this.expands = [];
          this.expands.push(row.usid);
        }
      },
      //查询宠物信息
      getPets(usid) {
        this.$axios.get(config.api_url + '/pets/'+usid
        ).then(response => {
          let data = response.data;
          if(data.state) {
            this.petsTabs = [];
            if(data.msg && data.msg.length > 0) {
              for(const item of data.msg) {
                this.petsTabs.push(item);
              }
              this.petsAction = this.petsTabs[0].pet_name;
            }
          } else {
            this.$message({
              message: '获取宠物失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取宠物异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //查询地址信息
      getAddress(usid) {
        this.$axios.get(config.api_url + '/address/user/'+usid
        ).then(response => {
          let data = response.data;
          if(data.state) {
            this.addressTabs = [];
            for(const item of data.msg) {
              this.addressTabs.push(item);
            }
          } else {
            this.$message({
              message: '获取地址失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '客户暂无地址',
            type: 'error'
          });
        });
      },
      showEdit(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.level = row.level.toString();
        this.editForm.user_status = row.user_status.toString();
        this.editForm.refid = row.refid.toString();
      },
      editSubmit() {
        this.editForm.level = parseInt(this.editForm.level);
        this.editForm.user_status = parseInt(this.editForm.user_status);
        this.editForm.refid = parseInt(this.editForm.refid);
        this.$axios.put(config.api_url + '/userinfo', this.editForm
        ).then(response => {
          if(response.data.state) {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            this.editFormVisible = false;
            this.search();
          } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
      },
      showOrder(usid, orderNum) {
        this.$router.push('/order/list/'+usid+'/'+orderNum);
      },
      getFanli(usid) {
        this.$axios.get(config.api_url + '/fanli/user/'+usid
        ).then(response => {
          let data = response.data;
          if(data.state) {
            this.tableFanli = data.msg;
          } else {
            this.$message({
              message: '获取返利失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '暂无返利订单',
            type: 'error'
          });
        });
      },
      showComment(usid) {
        this.$router.push('/comment/0/'+usid);
      }
    },
    created() {
      this.usid = parseInt(this.$route.params.usid);
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
</style>



// WEBPACK FOOTER //
// List.vue?dc725a18